import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Router, ActivatedRoute } from "@angular/router";
import { BsModalService } from "ngx-bootstrap/modal";
import { SalesManagerShopItemsService } from "./salesmanagershopitems.service";
import { AlertService, BaseMaterialDatatableComponent, ConfirmDialogComponent } from "@impacgroup/angular-baselib";
import { SalesManagerShopItem } from "../../api-models/SalesManagerShopItem";
import { SalesManagerShopItemsMainComponent } from "./salesmanagershopitems.main.component";
import { PermissionService } from "@impacgroup/angular-oauth-base";

@Component({
    selector: "app-salesmanagershopitems",
    templateUrl: "./salesmanagershopitems.component.html",
    styleUrls: ["salesmanagershopitems.component.scss"],
    standalone: false
})
export class SalesManagerShopItemsComponent extends BaseMaterialDatatableComponent<SalesManagerShopItem> implements OnInit {
    public UTCDATEFORMAT: string = "";

    rows: SalesManagerShopItem[] = [];
    hasEditPermissions: boolean = false;

    constructor(
        private salesManagerShopItemsService: SalesManagerShopItemsService,
        private translateService: TranslateService,
        private permissionService: PermissionService,
        private router: Router,
        private route: ActivatedRoute,
        private modalService: BsModalService,
        private alertService: AlertService,
        parent: SalesManagerShopItemsMainComponent
    ) {
        super({
            stateSaveConfig: {
                stateSaveMode: salesManagerShopItemsService.datatableStateSaveMode,
                stateSaveComponent: parent,
                stateSaveStorageKey: "dtstate_shop_items_list"
            },
            sortState: {
                active: "materialNumber",
                direction: "asc"
            },
            displayedColumns: ["name", "materialNumber", "category", "inactive", "created", "updated", "actions"],
            listService: salesManagerShopItemsService
        });

        this.UTCDATEFORMAT = this.salesManagerShopItemsService.UTCDATEFORMAT;
        this.hasEditPermissions = this.permissionService.hasPermission("SALESMANAGERSHOPITEMS.EDIT");
    }

    addSalesManagerShopItem() {
        this.router.navigate(["add"], { relativeTo: this.route });
    }

    editSalesManagerShopItem(id: string) {
        this.router.navigate([id], { relativeTo: this.route });
    }

    deleteSalesManagerShopItem(id: string) {
        const initialState = {
            title: this.translateService.instant("salesmanagershopitems.list.delete.title"),
            message: this.translateService.instant("salesmanagershopitems.list.delete.message"),
            closeBtnName: this.translateService.instant("global.buttons.close"),
            confirmBtnName: this.translateService.instant("global.buttons.ok")
        };
        const bsModalRef = this.modalService.show(ConfirmDialogComponent, { initialState });
        bsModalRef.content.confirmCallback = () => {
            this.subscriptions.push(
                this.salesManagerShopItemsService.deleteSalesManagerShopItem(id).subscribe((result) => {
                    this.alertService.addSuccess(this.translateService.instant("salesmanagershopitems.list.delete.success"));
                    this.loadData();
                })
            );
        };
    }

    onInactiveToggle(item: SalesManagerShopItem) {
        item.inactive = !item.inactive;
        this.subscriptions.push(
            this.salesManagerShopItemsService.updateSalesManagerShopItem(item).subscribe({
                next: () => {
                    this.loadData();
                    this.alertService.addSuccess(this.translateService.instant("salesmanagershopitems.detail.edit.success"));
                },
                error: (err) => {
                    this.alertService.addError(err);
                }
            })
        );
    }
}
